import { Link } from 'react-router-dom'
import { BreadcrumbItemType } from 'antd/es/breadcrumb/Breadcrumb'

export default function ItemRender(route: Partial<BreadcrumbItemType>) {
  return route.path ? (
    <Link className="text-xs text[#868C94] font-medium" to={route.path as string}>
      {route.title}
    </Link>
  ) : (
    <span className="text-xs text-[#3C5337] font-medium ">{route.title}</span>
  )
}
